import axios from 'axios'
import store from '../store'

function getBrowserInfo () {
  return {
    userAgent: navigator.userAgent,
    language: navigator.language,
    currentUrl: window.location.href
  }
}

function buildPayload (error, browserInfo) {
  return {
    message: error.message || 'Unknown error',
    stack: error.stack || null,
    url: error.config?.url || error.url || null,
    method: error.config?.method || null,
    status: error.response?.status || null,
    responseData: error.response?.data || null,
    browser: browserInfo,
    type: error.type,
    cduid: store.state.application.cduid
  }
}

function reportErrorToBackend (error) {
  const leadAPIUrl = process.env.VUE_APP_LEAD_API_PERSONAL_LOANS_BASE_URL
  const errorLoggingRoute = process.env.VUE_APP_LEAD_API_ERROR_ENDPOINT
  const logErrorEndpoint = `${leadAPIUrl}${errorLoggingRoute}`

  const browserInfo = getBrowserInfo()

  // Prevent recursion only for actual Axios errors with a config
  const errorUrl = error?.config?.url || error?.url
  if (errorUrl && errorUrl.includes(errorLoggingRoute)) {
    return // skip logging this one
  }

  const payload = buildPayload(error, browserInfo)

  axios.post(logErrorEndpoint, payload).catch(err => {
    console.warn('Logging to backend failed:', err)
  })
}

export default reportErrorToBackend
